import { Storage } from '@/modules/plugins/storage'
import Vue from 'vue'

const state = {
    restaurant: {},
    currency: {},
    canteen: Storage.getItem('canteen') || {},
    deliveryTimeChanged: false,
    deliveryFeeChanged: false,
}
const mutations = {
    SET_RESTAURANT(state, payload) {
        state.restaurant = payload || {}
    },
    RESET_RESTAURANT(state) {
        state.restaurant = {}
    },
    SET_CURRENCY(state, payload) {
        state.currency = payload || {}
    },
    RESET_CURRENCY(state) {
        state.currency = {}
    },
    SET_CANTEEN(state, payload) {
        state.canteen = payload || {}
    },
    RESET_CANTEEN(state) {
        state.canteen = {}
    },
    SET_DELIVERY_TIME_CHANGE(state, payload) {
        state.deliveryTimeChanged = payload
    },
    SET_DELIVERY_FEE_CHANGE(state, payload) {
        state.deliveryFeeChanged = payload
    },
}

const actions = {
    setRestaurant({ commit }, payload) {
        commit('SET_RESTAURANT', payload)
    },
    resetRestaurant({ commit }) {
        commit('RESET_RESTAURANT')
    },
    setCurrency({ commit }, payload) {
        commit('SET_CURRENCY', payload)
    },
    resetCurrency({ commit }) {
        commit('RESET_CURRENCY')
    },
    setCanteen({ commit, state }, payload) {
        commit('SET_CANTEEN', payload)
        Storage.setItem('canteen', state.canteen)
        Vue.prototype.$cart.canteen = state.canteen
    },
    resetCanteen({ commit }) {
        commit('RESET_CANTEEN')
        Storage.removeItem('canteen')
        Vue.prototype.$cart.canteen = undefined
    },
    setDeliveryTimeChange({ commit }, payload) {
        commit('SET_DELIVERY_TIME_CHANGE', payload)
    },
    setDeliveryFeeChange({ commit }, payload) {
        commit('SET_DELIVERY_FEE_CHANGE', payload)
    },
}

const getters = {
    restaurant: (state) => state.restaurant,
    currency: (state) => state.currency,
    canteen: (state) => state.canteen,
    deliveryTimeChanged: (state) => state.deliveryTimeChanged,
    deliveryFeeChanged: (state) => state.deliveryFeeChanged,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
